/**
 *
 */
import { get, post,put,upload,downloadTemplate} from 'mdoc/admin/axios/tools'
import * as config from 'mdoc/admin/axios/config'

//ユーザ一覧
export const getUser = (param) => new Promise((resolve, reject)=> {
    get(config.USER, param)
        .then(function (response) {
            if (response.error) {
                reject(response.errorMessage);
            } else {
                resolve({results: response.docTblUserList, count: response.count})
            }
        }).catch(function (error) {
            reject(error);
    })
})

//ユーザ一覧削除
export const userDelete = (param) => new Promise((resolve, reject)=> {
    get(config.USER_DELETE, param)
        .then(function (response) {
            if (response.error) {
                reject(response.errorMessage);
            } else {
                resolve({results: response})
            }
        }).catch(function (error) {
        reject(error);
    })
})
// ユーザ一覧認証リセット接口
export const putReset = (param) => new Promise((resolve, reject)=> {
    get(config.USERRESET, param)
        .then(function (response) {
            if (response.error) {
                reject(response.errorMessage)
            } else {
                resolve({results: response})
            }
        }).catch(function (error) {
        reject(error);
    })
})
// ユーザ一覧check email接口
export const getUserCheckEmail = (param) => new Promise((resolve, reject)=> {
    get(config.USERCHECKEMAIL, param)
        .then(function (response) {
            if (response.error) {
                reject(response.errorMessage)
            } else {
                resolve({results: response})
            }
        }).catch(function (error) {
        reject(error);
    })
})
// ユーザ登録详细接口
export const getUserDetail = (param) => new Promise((resolve, reject)=> {
    get(config.USERDETAIL, param)
        .then(function (response) {
            if (response.error) {
                reject(response.errorMessage)
            } else {
                resolve({results: response})
            }
        }).catch(function (error) {
        reject(error);
    })
})
// ユーザ部署検索接口
export const getDepartmentSearch = (param) => new Promise((resolve, reject)=> {
    get(config.DEPARTMENT_SEARCH, param)
        .then(function (response) {
            if (response.error) {
                reject(response.errorMessage)
            } else {
                resolve({results: response.docMstDepartmentList, count: response.count})
            }
        }).catch(function (error) {
        reject(error);
    })
})
// ユーザ新规登録接口
export const UserLogin = (param) => new Promise((resolve, reject)=> {
        post(config.USER, param)
            .then(function (response) {
                if (response.error) {
                    reject(response.errorMessage)
                } else {
                    resolve({results: response})
                }
            }).catch(function (error) {
            reject(error);
        })
})
// ユーザ更新登録接口
export const UserNewLogin = (param) => new Promise((resolve, reject)=> {
        put(config.USER, param)
            .then(function (response) {
                if (response.error) {
                    reject(response.errorMessage)
                } else {
                    resolve({results: response})
                }
            }).catch(function (error) {
            reject(error);
        })
})

// ユーザ検索接口
export const getUserSearch = (param) => new Promise((resolve, reject)=> {
    get(config.USER_SEARCH, param)
        .then(function (response) {
            if (response.error) {
                reject(response.errorMessage);
            } else {
                resolve({results: response.docTblUserList, count: response.count})
            }
        }).catch(function (error) {
        reject(error);
    })
})

// ユーザ一括登録upload
export const userAllUpload = (param) => new Promise((resolve, reject)=> {
    upload(config.USER_ALL_UPLOAD, param)
        .then(function (response) {
            if (response.error) {
                reject(response.errorMessage);
            } else {
                resolve({results: response})
            }
        }).catch(function (error) {
        reject(error);
    })
})

// ユーザ一括登録download
export const getFilePath = (name,param) => new Promise((resolve, reject)=> {
    downloadTemplate(config.USER_ALL_DOWNLOAD, param)
        .then(res => {
            var blob = new Blob([res], {type: 'application/vnd.ms-excel;charset=utf-8'});
            if (window.navigator.msSaveOrOpenBlob) {
                window.navigator.msSaveBlob(blob,name);
            }else{
                var downloadElement = document.createElement('a');
                var href = window.URL.createObjectURL(blob);
                downloadElement.href = href;
                downloadElement.download = name;
                document.body.appendChild(downloadElement);
                downloadElement.click();
                document.body.removeChild(downloadElement);
                window.URL.revokeObjectURL(href);
            }
        })
        .then(data => {
            resolve(data);
        }).catch(function (error) {
        reject(error);
    })
})
// ユーザログ
export const getUserLog = (param) => new Promise((resolve, reject)=> {
    get(config.USER_LOG, param)
        .then(function (response) {
            // if (response.error) {
            //     reject(response.errorMessage)
            // } else {
                resolve({results: response.docTblBookEffectiveLogList, count: response.count})
            // }
        }).catch(function (error) {
            reject(error);
    })
})
// ユーザログDownload
export const userLogDownload = (name,param) => new Promise((resolve, reject)=> {
    downloadTemplate(config.USER_LOG_DOWNLOAD, param)
        .then(res => {
            var blob = new Blob([res], {type: 'application/vnd.ms-excel;charset=utf-8'});
            if (window.navigator.msSaveOrOpenBlob) {
                window.navigator.msSaveBlob(blob,name);
            }else{
                var downloadElement = document.createElement('a');
                var href = window.URL.createObjectURL(blob);
                downloadElement.href = href;
                downloadElement.download = name;
                document.body.appendChild(downloadElement);
                downloadElement.click();
                document.body.removeChild(downloadElement);
                window.URL.revokeObjectURL(href);
            }
        })
        .then(data => {
            resolve(data);
        }).catch(function (error) {
        reject(error);
    })
})
